import React from "react";
import {Box, Divider, Stack} from "@mui/material";
import DataObjectIcon from "@mui/icons-material/DataObject";
import type {Editor} from "@tiptap/core";
import {useTranslation} from "react-i18next";
import PrintoutBlockSettingsSection from "./blockSettings/PrintoutBlockSettingsSection";
import VariableSettings from "./blockSettings/VariableSettings";
import {PanelHint, PanelSection} from "./PrintoutPanelSection";
import {
    useSelectedPrintoutBlock,
    useSelectedPrintoutVariable,
} from "./useSelectedPrintoutBlock";

type Props = {
    editor: Editor | null
    disabled?: boolean
};

export function PrintoutSettingsPanel({editor, disabled}: Props) {
    const {t} = useTranslation();
    const selectedBlock = useSelectedPrintoutBlock(editor);
    const selectedVariable = useSelectedPrintoutVariable(editor);

    return (
        <Stack sx={{height: '100%', minHeight: 0}}>
            <Box sx={{flex: 1, minHeight: 0, overflowY: 'auto', px: 2, pt: 0.5, pb: 1.5}}>
                <Stack gap={3} divider={<Divider/>} sx={{pt: 3}}>
                    {!!editor && !!selectedVariable && (
                        <PanelSection icon={<DataObjectIcon fontSize={'small'}/>} title={t('Variable')}>
                            <VariableSettings
                                disabled={disabled}
                                editor={editor}
                                variable={selectedVariable}
                            />
                        </PanelSection>
                    )}

                    {!!editor && !selectedVariable && !!selectedBlock && (
                        <PrintoutBlockSettingsSection
                            block={selectedBlock}
                            disabled={disabled}
                            editor={editor}
                        />
                    )}

                    {!selectedBlock && !selectedVariable && (
                        <PanelHint>
                            {t('Select a block to edit its settings')}
                        </PanelHint>
                    )}
                </Stack>
            </Box>
        </Stack>
    );
}

export default PrintoutSettingsPanel;
